export var fonts = {
    heading: 'BerlingskeSerif, Georgia, "Times New Roman", Times, serif',
    body: 'LotaGrotesque, --apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
    speech: "JennaSue, cursive",
    password: "Password",
    mobile: 'Bariol, --apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
};
